import { generateCSS } from 'Common/components/Form';

const stylesGenerator = () => ({
  notAllowed: generateCSS({
    cursor: 'not-allowed'
  })
});

export default stylesGenerator;
